import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import EnquiryModal from "../../Components/EnquiryModal";
import "../../App.css";

import socket_thimble from "../../Assets/socket_thimble.webp";
import socket_tongue from "../../Assets/socket_tongue.webp";
import socket_clevis from "../../Assets/socket_clevis.webp";
import clevis_twisted from "../../Assets/clevis_twisted.webp";
import strap_terminating from "../../Assets/strap_terminating.webp";
import strap_section_terminal from "../../Assets/strap_section_terminal.webp";
import link_single from "../../Assets/link_single.webp";
import link_parallel from "../../Assets/link_parallel.webp";
import link_parallel_conversion from "../../Assets/link_parallel_conversion.webp";
import link_cranked from "../../Assets/link_cranked.webp";
import link_chain from "../../Assets/link_chain.webp";
import link_extension from "../../Assets/link_extension.webp";
import plate_landing from "../../Assets/plate_landing.webp";
import sag_adjuster_plate from "../../Assets/sag_adjuster_plate.webp";
import plate_yoke from "../../Assets/plate_yoke.webp";
import thimble_clevis from "../../Assets/thimble_clevis.webp";
import ball_ended_eye_link_horn_holder_twisted from "../../Assets/ball_ended_eye_link_horn_holder_twisted.webp";
import bracket_post_insulator from "../../Assets/bracket_post_insulator.webp";
import swinging_clevis from "../../Assets/swinging_clevis.webp";
import secondary_racks from "../../Assets/secondary_racks.webp";
import binding_strirrups from "../../Assets/binding_strirrups.webp";
import tension_clamp_compression_type from "../../Assets/tension_clamp_compression_type.webp";
import tension_clamp_snail_type from "../../Assets/tension_clamp_snail_type.webp";
import straight_line_clamp from "../../Assets/straight_line_clamp.webp";
import helically_formed_service_dead_end from "../../Assets/helically_formed_service_dead_end.webp";
import helically_formed_top_tie from "../../Assets/helically_formed_top_tie.webp";
import helically_formed_side_tie from "../../Assets/helically_formed_side_tie.webp";
import ball_ended_eye_link from "../../Assets/ball_ended_eye_link.webp";
import ball_ended_eye_link_horn_holder from "../../Assets/ball_ended_eye_link_horn_holder.webp";
import ball_ended_hook_pig_tail_hook from "../../Assets/ball_ended_hook_pig_tail_hook.webp";
import line_post_insulator_stud from "../../Assets/line_post_insulator_stud.webp";
import ball_clevis from "../../Assets/ball_clevis.webp";
import tension_clamp_bolted_type from "../../Assets/tension_clamp_bolted_type.webp";
import armour_rod from "../../Assets/armour_rod.webp";
import helically_formed_dead_end_grip from "../../Assets/helically_formed_dead_end_grip.webp";
import bracket_d_iron from "../../Assets/bracket_d_iron.webp";

function Insulator_fittings_and_accessories() {
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const openEnquiryModal = (product) => {
    setSelectedProduct(product);
    setShowEnquiry(true);
  };

  const products = [
    {
      id: 1,
      name: "Socket Thimble",
      image: socket_thimble,
      specs: {
        application: "Overhead Line Hardware",
        material: "Forged Steel",
        finish: "Galvanized",
        color: "Metallic Grey",
        warranty: "1 Year",
        supply: "8,000 Units / Month",
      },
    },
    {
      id: 2,
      name: "Socket Tongue",
      image: socket_tongue,
      specs: {
        application: "Transmission Lines",
        material: "Steel",
        finish: "Protective Coating",
        color: "Grey",
        warranty: "1 Year",
        supply: "9,000 Units / Month",
      },
    },
    {
      id: 3,
      name: "Socket Clevis",
      image: socket_clevis,
      specs: {
        application: "Industrial Power Fittings",
        material: "Cast Iron",
        finish: "Anti-Corrosive Coated",
        color: "Grey",
        warranty: "1 Year",
        supply: "10,000 Units / Month",
      },
    },
    // {
    //   id: 4,
    //   name: "Ball Clevis – Horn Holder",
    //   image: ball_clevis,
    //   specs: {
    //     application: "Electrical Line Hardware",
    //     material: "Metal Alloy",
    //     finish: "Surface Coated",
    //     color: "Grey",
    //     warranty: "1 Year",
    //     supply: "10,000 Units / Month",
    //   },
    // },
    {
      id: 5,
      name: "Twisted Clevis",
      image: clevis_twisted,
      specs: {
        application: "Power Line Accessories",
        material: "Steel",
        finish: "Weather Resistant",
        color: "Grey",
        warranty: "1 Year",
        supply: "7,500 Units / Month",
      },
    },
    {
      id: 6,
      name: "Strap Terminating",
      image: strap_terminating,
      specs: {
        application: "Transmission Hardware",
        material: "GI Steel",
        finish: "Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "6,000 Units / Month",
      },
    },
    {
      id: 7,
      name: "Strap Section & Terminal",
      image: strap_section_terminal,
      specs: {
        application: "Line Fittings",
        material: "Steel",
        finish: "Rust Proof",
        color: "Metal Grey",
        warranty: "1 Year",
        supply: "6,500 Units / Month",
      },
    },
    {
      id: 8,
      name: "Single Link",
      image: link_single,
      specs: {
        application: "Electrical Hardware",
        material: "Forged Steel",
        finish: "Coated",
        color: "Grey",
        warranty: "1 Year",
        supply: "12,000 Units / Month",
      },
    },
    {
      id: 9,
      name: "Link Parallel",
      image: link_parallel,
      specs: {
        application: "Power Transmission",
        material: "Steel",
        finish: "Galvanized",
        color: "Metallic",
        warranty: "1 Year",
        supply: "12,000 Units / Month",
      },
    },
    {
      id: 10,
      name: "Link Parallel Conversion",
      image: link_parallel_conversion,
      specs: {
        application: "Overhead Line Hardware",
        material: "HDGI Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "15,000 Units / Month",
      },
    },
    {
      id: 11,
      name: "Link Cranked",
      image: link_cranked,
      specs: {
        application: "Overhead Transmission Lines",
        material: "Forged Steel",
        finish: "Hot Dip Galvanized",
        color: "Grey",
        warranty: "1 Year",
        supply: "5,000 Units / Month",
      },
    },
    {
      id: 12,
      name: "Link Chain",
      image: link_chain,
      specs: {
        application: "Stay & Strain Insulator Assembly",
        material: "Galvanized Steel",
        finish: "Hot Dip Galvanized",
        color: "Metallic",
        warranty: "1 Year",
        supply: "20,000 Units / Month",
      },
    },
    {
      id: 13,
      name: "Link Extension",
      image: link_extension,
      specs: {
        application: "Overhead Line Extension Hardware",
        material: "HDGI Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "5,000 Units / Month",
      },
    },
    {
      id: 14,
      name: "Plate Landing",
      image: plate_landing,
      specs: {
        application: "Transmission Line Fittings",
        material: "High Tensile Steel",
        finish: "Hot Dip Galvanized",
        color: "Grey",
        warranty: "1 Year",
        supply: "Project Based",
      },
    },
    {
      id: 15,
      name: "Plate Sag Adjuster",
      image: sag_adjuster_plate,
      specs: {
        application: "Sag Adjustment in Overhead Lines",
        material: "HDGI Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Sets / Month",
      },
    },
    {
      id: 16,
      name: "Plate Yoke",
      image: plate_yoke,
      specs: {
        application: "Insulator String Assembly",
        material: "HDGI Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Sets / Month",
      },
    },
    {
      id: 17,
      name: "Bracket - Post Insulator",
      image: bracket_post_insulator,
      specs: {
        application: "Post Insulator Mounting",
        material: "HDGI Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Sets / Month",
      },
    },
    {
      id: 18,
      name: "Swinging Clevis",
      image: swinging_clevis,
      specs: {
        application: "Insulator String Hardware",
        material: "Forged Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Units / Month",
      },
    },
    {
      id: 19,
      name: "Secondary Racks",
      image: secondary_racks,
      specs: {
        application: "Conductor & Cable Support",
        material: "HDGI Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Units / Month",
      },
    },
    {
      id: 20,
      name: "Binding Strirrups",
      image: binding_strirrups,
      specs: {
        application: "Conductor Binding & Support",
        material: "Galvanized Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Units / Month",
      },
    },
    {
      id: 21,
      name: "Tension Clamp - Compression Type",
      image: tension_clamp_compression_type,
      specs: {
        application: "Conductor Tensioning",
        material: "Aluminium Alloy / Steel",
        finish: "Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Sets / Month",
      },
    },
    {
      id: 22,
      name: "Tension Clamp - Snail Type",
      image: tension_clamp_snail_type,
      specs: {
        application: "Overhead Conductor Dead-End",
        material: "Forged Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Sets / Month",
      },
    },
    {
      id: 23,
      name: "Thimble Clevis",
      image: thimble_clevis,
      specs: {
        application: "Stay Wire Termination",
        material: "Forged Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Units / Month",
      },
    },
    {
      id: 24,
      name: "Straight Line Clamp",
      image: straight_line_clamp,
      specs: {
        application: "Straight Line Conductor Support",
        material: "Aluminium Alloy",
        finish: "Natural / Galvanized",
        color: "Metallic",
        warranty: "1 Year",
        supply: "25,000 Units / Month",
      },
    },
  ];

  const itemsPerPage = 12;
  const totalPages = Math.ceil(products.length / itemsPerPage);

  const currentProducts = products.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <Container>
      <Row className="mt-5">
        {currentProducts.map((product) => (
          <Col md={6} key={product.id} className="mb-4">
            <Card className="product-card-box h-100">
              <Row className="g-0">
                <Col md={5} className="p-3 text-center">
                  <Card.Img
                    src={product.image}
                    alt={product.name}
                    style={{ maxHeight: "220px", objectFit: "contain" }}
                  />
                </Col>

                <Col md={7}>
                  <Card.Body>
                    <Card.Title className="fw-bold text-dark">
                      {product.name}
                    </Card.Title>

                    <div className="small text-muted mb-3">
                      <div>
                        <strong>Application:</strong>{" "}
                        {product.specs.application}
                      </div>
                      <div>
                        <strong>Material:</strong> {product.specs.material}
                      </div>
                      <div>
                        <strong>Finish:</strong> {product.specs.finish}
                      </div>
                      <div>
                        <strong>Color:</strong> {product.specs.color}
                      </div>
                      <div>
                        <strong>Warranty:</strong> {product.specs.warranty}
                      </div>
                      <div>
                        <strong>Supply Capacity:</strong> {product.specs.supply}
                      </div>
                    </div>

                    <button
                      className="btn btn-primary"
                      onClick={() => openEnquiryModal(product)}
                    >
                      Send Enquiry
                    </button>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Pagination */}
      <div className="text-center my-4">
        <button
          className="btn btn-outline-primary mx-2"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
        >
          Previous
        </button>

        <span className="fw-semibold">
          Page {currentPage} of {totalPages}
        </span>

        <button
          className="btn btn-outline-primary mx-2"
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(currentPage + 1)}
        >
          Next
        </button>
      </div>

      {showEnquiry && selectedProduct && (
        <EnquiryModal
          show={showEnquiry}
          onHide={() => setShowEnquiry(false)}
          product={selectedProduct}
        />
      )}
    </Container>
  );
}

export default Insulator_fittings_and_accessories;
